import React from 'react';
import { usePayment } from '../../../context/contextPayment';

const ToggleSwitch = () => {
  const {
    isYearly, setIsYearly,
  } = usePayment();
  
  return (
    <div className="mb-lg-5 mb-3">
      <ul className="nav nav-pills nav-fill p-1 fs-6 small rounded-5 border border-1 shadow-sm" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${!isYearly ? "active fw-bold" : "fw-semibold"} rounded-5`}
            onClick={() => setIsYearly(false)} 
            type="button" role="tab"
            aria-selected={!isYearly}
          >Monthly
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${isYearly ? "active fw-bold" : "fw-semibold"} rounded-5`}
            onClick={() => setIsYearly(true)} 
            type="button" role="tab"
            aria-selected={isYearly}
          >Yearly
          </button>
        </li>
      </ul>
  </div> 
  );
};

export default ToggleSwitch;